import React from 'react';
import ModifiersState from './modifiersState/ModifiersState';
import ModalWindows from './components/ModalWindows/ModalWindows';
import ModifiersControlPanel from './components/ModifiersControlPanel/ModifiersControlPanel';
import Modifiers from './components/Modifiers/Modifiers';
import style from './index.module.scss';

const ModifiersPage: React.FC = () => {
	return (
		<ModifiersState>
			<div className={style.container} data-test="ModifiersPage">
				<ModifiersControlPanel />
				<Modifiers />
				<ModalWindows />
			</div>
		</ModifiersState>
	);
};

export default ModifiersPage;
